import { useShortcut } from '@nsftx/seven-nxg-retail-vue-sdk'
import { useWidgetsStore } from '@/stores/widgets/widgetsStore'

export const useWidgetShortcuts = () => {
  const { toggleCalculator, toggleShortcuts, toggleLatestBetslips } = useWidgetsStore()

  useShortcut('TOGGLE_CALCULATOR', toggleCalculator)
  useShortcut('TOGGLE_SHORTCUTS', toggleShortcuts)
  useShortcut('TOGGLE_LATEST_BETSLIPS', toggleLatestBetslips)
}
